<template>
    <div>
        <!-- DIALOGO DE LOADING -->
        <Dialog :visible.sync="loading" :closable="false" :containerStyle="{ width: '300px' }" :modal="true">
            <ProgressBar mode="indeterminate" style="height: .5em" />
            <div
                class="scalein animation-duration-2000 animation-iteration-infinite flex align-items-center justify-content-center font-bold border-round m-2 px-5 py-3">
                {{ loadingMensaje }}</div>
        </Dialog>
        <ScrollTop />
        <ScrollPanel style="height: 700px">

            <Button class="mt-5 mr-2" @click="closeDialogPdf"> Cerrar</Button>
            <Button class="mt-5 mr-2" @click="descargaComprobanteXml"> Descargar XML</Button>
            <Button class="mt-5 mr-2" @click="descargaComprobante"> Descargar PDF</Button>
            <Button class="mt-5 mr-2" @click="enviaCorreo"> Enviar</Button>

            <!-- <div> -->

            <div style="height: auto;" id="invoice">

                <!-- CABECERA DEL COMPROBANTE -->
                <div class="p-d-flex justify-center p-fluid grid formgrid col-12">
                    <div class="md:col-6">
                        <a href="https://contago.com.mx/" target="_blank">
                            <img :src="datosEmpresa.logo.base64" width="250">
                        </a>
                    </div>
                    <div class="md:col-6 text-right">
                        <font size="4">
                            <div><strong>Factura</strong></div>
                        </font>
                        <font size="3">
                            <div>{{ datosEmpresa.rfc }}</div>
                        </font>
                        <font size="3">
                            <div>{{ datosEmpresa.nombre }}</div>
                        </font>
                        <font size="2">
                            <div>{{ datosEmpresa.regimenFiscal.regimenFiscal }}</div>
                        </font>
                    </div>
                    <!-- </div> -->
                    <!-- DATOS DEL CLIENTE -->
                    <!-- <div class="p-d-flex justify-center p-fluid grid formgrid col-12"> -->
                    <div class="md:col-6 text-left">
                        <font size="3">
                            <div>Datos del cliente:</div>
                        </font>
                        <font size="3">
                            <div><strong>{{ item.cliente.cliente }}</strong></div>
                        </font>
                        <font size="1">
                            <div>{{ item.cliente.regimenFiscal.regimenFiscal }}</div>
                        </font>
                        <font size="2">
                            <div>{{ item.cliente.usoCfdi.usoCfdi }}</div>
                        </font>
                        <font size="2">
                            <div>{{ item.cliente.domicilioFiscal }}</div>
                        </font>
                        <font size="2">
                            <div>{{ item.cliente.direccion }}</div>
                        </font>
                    </div>
                    <div class="md:col-6 text-right">
                        <h3>{{ item.serie }} {{ item.folio }}</h3>
                        <div><b>Fecha: </b>{{ formatDate(item.fecha) }}</div>
                        <div><b>Moneda: </b>{{ item.moneda.clave }}</div>
                        <div><b>Tipo de comprobante: </b>I | Ingreso</div>
                        <div><b>Lugar de Expedición: </b>{{ datosEmpresa.domicilioFiscal }}</div>
                    </div>
                    <!-- </div> -->
                    <!-- <div class="p-d-flex justify-center p-fluid grid formgrid col-12"> -->
                    <div class="col-4 text-center">
                        <p class="font-bold" style="font-size: 12px">Metodo de Pago</p>
                        <p style="font-size: 12px">{{ item.metodoPago.metodoPago }}</p>
                    </div>
                    <div class="col-4 text-center">
                        <p class="font-bold" style="font-size: 12px">Forma de Pago</p>
                        <p style="font-size: 12px">{{ item.formaPago.formaPago }}</p>
                    </div>
                    <div class="col-4 text-center">
                        <p class="font-bold" style="font-size: 12px">Condiciones de Pago</p>
                        <p style="font-size: 12px">{{ item.condicionesPago }}</p>
                    </div>
                    <!-- </div> -->
                    <!-- DOCUMENTOS RELACIONADOS -->
                    <template v-if="item.cfdiRelacionados[0].cfdiRelacionados.length != 0">
                        <!-- <div class="p-d-flex justify-center p-fluid grid formgrid col-12"> -->
                        <div v-for="rel in item.cfdiRelacionados" :key="rel.item">
                            <DataTable class="mt-1" :value="rel.cfdiRelacionados" responsiveLayout="scroll">
                                <template #header>
                                    {{ rel.tipoRelacion.tipoRelacion }}
                                </template>
                                <Column field="serie" header="Serie"
                                    :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '65%' }">
                                </Column>
                                <Column field="folio" header="Folio"
                                    :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '65%' }">
                                </Column>
                                <Column field="fecha" header="Fecha"
                                    :styles="{ 'flex-grow': '1', 'flex-basis': '150px', 'font-size': '65%' }">
                                </Column>
                                <Column field="rfc" header="RFC"
                                    :styles="{ 'flex-grow': '1', 'flex-basis': '150px', 'font-size': '65%' }">
                                </Column>
                                <Column field="nombre" header="Nombre"
                                    :styles="{ 'flex-grow': '1', 'flex-basis': '150px', 'font-size': '65%' }">
                                </Column>
                                <Column field="subTotal" header="SubTotal"
                                    :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '65%', 'text-align': 'right' }">
                                    <template #body="{ data }">
                                        <span>{{ formatCurrency(data.subTotal) }}</span>
                                    </template>
                                </Column>
                                <Column field="total" header="Total"
                                    :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '65%', 'text-align': 'right' }">
                                    <template #body="{ data }">
                                        <span>{{ formatCurrency(data.total) }}</span>
                                    </template>
                                </Column>
                                <Column field="uuid" header="FolioFiscal"
                                    :styles="{ 'flex-grow': '1', 'flex-basis': '150px', 'font-size': '65%' }">
                                </Column>
                            </DataTable>
                            <hr color="#FF9100">
                        </div>
                        <!-- </div> -->
                    </template>
                    <!-- CONCEPTOS -->
                    <div class="col-12 page-break-inside" style="height: 100%;">

                        <DataTable style="width:100%; " class="page-break-inside p-datatable-sm" :value="primeraParte"
                            responsiveLayout="scroll">
                            <Column field="descripcion" header="Descripción" class="flex"
                                :styles="{ 'flex-grow': '1', 'flex-basis': '150px', 'font-size': '87%' }">
                                <template #body="{ data }">
                                    <h4>{{ data.descripcion }}</h4>
                                    <div>{{ data.claveProdServ.clave }}</div>
                                </template>
                            </Column>
                            <Column field="cantidad" header="Cantidad"
                                :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '87%' }">
                            </Column>
                            <Column field="claveUnidad.claveUnidad" header="Clave Unidad"
                                :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '87%' }">
                            </Column>
                            <Column field="valorUnitario" header="Valor Unitario"
                                :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '87%', 'text-align': 'right' }">
                                <template #body="{ data }">
                                    <span>{{ formatCurrency(data.valorUnitario) }}</span>
                                </template>
                            </Column>
                            <Column field="importe" header="Importe"
                                :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '87%', 'text-align': 'right' }">
                                <template #body="{ data }">
                                    <span>{{ formatCurrency(data.importe) }}</span>
                                </template>
                            </Column>

                        </DataTable>
                        <template v-if="segundaParte.length != 0">
                            <DataTable style="width:100%;" :header="false" class="page-break-inside p-datatable-sm"
                                :value="segundaParte" responsiveLayout="scroll">
                                <Column field="descripcion" header="Descripción" class="flex"
                                    :styles="{ 'flex-grow': '1', 'flex-basis': '150px', 'font-size': '87%' }">
                                    <template #body="{ data }">
                                        <h4>{{ data.descripcion }}</h4>
                                        <div>{{ data.claveProdServ.claveProdServ }}</div>
                                    </template>
                                </Column>
                                <Column field="cantidad" header="Cantidad"
                                    :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '87%' }">
                                </Column>
                                <Column field="claveUnidad.claveUnidad" header="Clave Unidad"
                                    :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '87%' }">
                                </Column>
                                <Column field="valorUnitario" header="Valor Unitario"
                                    :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '87%', 'text-align': 'right' }">
                                    <template #body="{ data }">
                                        <span>{{ formatCurrency(data.valorUnitario) }}</span>
                                    </template>
                                </Column>
                                <Column field="importe" header="Importe"
                                    :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '87%', 'text-align': 'right' }">
                                    <template #body="{ data }">
                                        <span>{{ formatCurrency(data.importe) }}</span>
                                    </template>
                                </Column>
                            </DataTable>
                        </template>

                    </div>
                    <!-- SUMAS DE IMPORTES E IMPORTE CON LETRA -->
                    <!-- <div class="p-d-flex justify-center p-fluid grid formgrid col-12"> -->
                    <!-- <div class="p-d-flex justify-center p-fluid grid formgrid col-12"> -->

                    <div class="col-8 text-left">
                        <p style="font-size: 12px"><strong>Importe con letra: </strong> {{ importeLetra }}
                        </p>
                        <br>
                        <template v-if="item.timbreFiscalDigital.folioFiscal != ''">
                            <p style="font-size: 12px"><strong>Fecha de Timbrado: </strong> {{
            item.timbreFiscalDigital.fechaTimbrado
        }}</p>
                            <p style="font-size: 12px"><strong>No. Certificado: </strong> {{
                item.timbreFiscalDigital.noCertificado
            }}</p>
                            <p style="font-size: 12px"><strong>No. Certificado SAT: </strong> {{
                item.timbreFiscalDigital.noCertificadoSAT
            }}</p>
                            <p style="font-size: 13px"> <strong>Folio Fiscal: </strong> {{
                item.timbreFiscalDigital.folioFiscal
            }}</p>
                        </template>
                    </div>
                    <div class="col-4">
                        <DataTable :value="itemsImpuestos" class="ocult" responsiveLayout="scroll">
                            <Column field="impuesto" header=""
                                :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '80%' }">
                            </Column>
                            <Column field="importe" header=""
                                :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '80%', 'text-align': 'right' }">
                                <template #body="{ data }">
                                    <span>{{ formatCurrency(data.importe) }}</span>
                                </template>
                            </Column>
                        </DataTable>
                        <!-- </div> -->
                    </div>
                    <template v-if="item.timbreFiscalDigital.folioFiscal != ''">
                        <!-- <div class="p-d-flex justify-center p-fluid grid formgrid col-12"> -->
                        <div class="col-3">
                            <a href="https://contago.com.mx/" target="_blank">
                                <img :src="imagenQR" width="160">
                            </a>
                        </div>
                        <div class="col-9 text-left" style="word-break: break-all;">
                            <p class="font-bold" style="font-size: 10px;">
                                Sello CFDI</p>
                            <!-- <p style="font-size: 9px">{{ item.timbreFiscalDigital.selloCFDI.base64 }}</p> -->
                            <div style="font-size: 9px;"><wbr> {{ item.timbreFiscalDigital.selloCFDI.base64 }}
                            </div>
                            <p class="font-bold" style="font-size: 10px">Sello SAT</p>
                            <!-- <p style="font-size: 9px">{{ item.timbreFiscalDigital.selloSAT.base64 }}</p> -->
                            <div style="font-size: 9px">{{ item.timbreFiscalDigital.selloSAT.base64 }}</div>
                            <p class="font-bold" style="font-size: 10px">Cadena Original</p>
                            <!-- <p style="font-size: 9px">{{ item.timbreFiscalDigital.cadenaOriginal }}</p> -->
                            <div style="font-size: 9px">{{ item.timbreFiscalDigital.cadenaOriginal }}</div>
                        </div>
                        <!-- </div> -->
                    </template>
                    <!-- <div class="p-d-flex justify-center p-fluid grid formgrid col-12"> -->
                    <div class="col">
                        <p style="font-size: 12px">{{ item.notas }}</p>
                    </div>
                    <!-- </div> -->
                    <!-- </div> -->
                </div>
            </div>
            <ScrollTop target="parent" :threshold="100" class="custom-scrolltop" icon="pi pi-arrow-up" />
        </ScrollPanel>
    </div>
</template>

<script>
import moment from "moment";
import html2pdf from "html2pdf.js";
import axios from 'axios'
import { numeroALetras } from '../../plugins/numeroALetras.js'

export default {
    components: {
        // numeroALetras,
    },
    data() {
        return {
            dialogCorreo: false,
            loadingMensaje: '',
            loading: false,
            destinatarios: [],
            nuevoDestinatario: {
                nombre: '',
                correo: ''
            },
            primeraParte: [],
            segundaParte: [],

            datosEmpresa: {
                logo: {
                    base64: ''
                },
                regimenFiscal: { regimenFiscal: '' }
            },
            correoEmisor: {}

        };
    },
    computed: {
        item() {
            return this.$store.state.facturaStore;
        },
        empresa() {
            return this.$store.state.usuario;
        },
        imagenQR() {
            let imagen = 'data:image/jpeg;base64,'
            return imagen + this.$store.state.facturaStore.timbreFiscalDigital.archioQr
        },
        importeLetra() {
            const func = require('../../plugins/numeroALetras.js')
            let a = func.numeroALetras(this.$store.state.facturaStore.total, this.$store.state.facturaStore.moneda.clave);
            return a;
        },
        itemsImpuestos() {
            var lista = [];
            var subTotal = { impuesto: 'SubTotal', importe: this.$store.state.facturaStore.subTotal }
            lista.push(subTotal)
            for (var x of this.$store.state.facturaStore.impuestos.traslados) {
                console.log(x)
                let nombre = '';
                let tasa = x.tasaOCuota * 100
                tasa = Math.round(tasa * 10000) / 10000

                if (x.impuesto === '001') {
                    nombre = 'ISR'
                }
                if (x.impuesto === '002') {
                    nombre = 'IVA'
                }
                if (x.impuesto === '003') {
                    nombre = 'IEPS'
                }

                if (x.tipoFactor === 'Exento') {
                    nombre = nombre + ' Exento'
                } else {
                    nombre = nombre + '(' + tasa + ')%'
                }
                var ob = { impuesto: nombre, importe: x.importe }
                lista.push(ob)
                ob = {};
            }
            for (var x of this.$store.state.facturaStore.impuestos.retenciones) {
                let nombre = '';
                let tasa = x.tasaOCuota * 100
                tasa = Math.round(tasa * 10000) / 10000

                if (x.impuesto === '001') {
                    nombre = 'ISR'
                }
                if (x.impuesto === '002') {
                    nombre = 'IVA'
                }
                if (x.impuesto === '003') {
                    nombre = 'IEPS'
                }

                nombre = nombre + '(' + tasa + ')%'
                var ob = { impuesto: nombre, importe: (x.importe) * -1 }
                lista.push(ob)
                ob = {};
            }
            var total = { impuesto: 'Total', importe: this.$store.state.facturaStore.total }
            lista.push(total)
            // console.log(lista)
            return lista;
        },
        correo() {
            return this.$store.state.correoStore
        },
        empresaInicial() {
            return this.$store.state.empresaEmisoraStore
        }

    },
    watch: {

    },
    created() {
        this.getCorreo();
        this.GetEmpresa()
        this.divirConceptos();
        this.GetCorreo();
    },
    methods: {
        async GetEmpresa() {
            try {
                let response = await axios.get('Empresas/GetEmpresa/' + this.empresaInicial.baseEmpresa);
                console.log('empresa', response.data)
                this.datosEmpresa = { ...response.data }
            } catch (error) {
                console.log(error);
            }
        },
        async GetCorreo() {
            try {
                let response = await axios.get('Empresas/GetCorreo/' + this.empresaInicial.baseEmpresa);
                console.log('correo', response.data)
                this.correoEmisor = { ...response.data }
            } catch (error) {
                console.log(error);
            }
        },
        divirConceptos() {
            if (this.item.conceptos.length > 10) {
                this.primeraParte = this.item.conceptos.slice(0, 10);
                this.segundaParte = this.item.conceptos.slice(10);
            }
            else {
                this.primeraParte = this.item.conceptos
            }
        },
        formatDate(date) {
            moment.locale('es-mx')
            let fechaR = moment(date).format("DD-MMMM-yyyy");
            return fechaR;
        },

        formatCurrency(value) {
            // return value.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },

        // OBTENEMOS LOS CORREOS DEL RECPTOR 
        async getCorreo() {
            this.correo.asunto = 'Se envía factura correspondiente'

            this.loadingMensaje = 'Espere...'
            this.loading = true
            let idCliente = this.item.cliente.idCliente
            console.log('aqui', idCliente)
            try {
                let response = await axios.get('Correos/GetCorreoEmpresa/' + this.empresa.empresaBase + '/' + idCliente);
                console.log(response)
                let correos = response.data;
                for (let c of correos) {
                    this.destinatarios.push(c)
                }
                this.loading = false
            } catch (error) {
                console.log(error)
                this.loading = false
            }
        },

        async exportToPDF() {
            var opt = {
                margin: .5,
                filename: this.item.folioFiscal + ".pdf",
                jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
                html2canvas: { scale: 4, letterRendering: true, },
                pagebreak: {
                    mode: ['avoid-all', 'css', 'legacy']
                },
                autoPaging: 'text'
            }

            //EXPORTA EL PDF
            html2pdf().from(document.getElementById('invoice')).set(opt).toPdf().get('pdf').then((pdf) => {
                var totalPages = pdf.internal.getNumberOfPages();
                // console.log(totalPages)
                for (let i = 1; i <= totalPages; i++) {
                    pdf.setPage(i);
                    pdf.setFontSize(10);
                    pdf.setTextColor(0);
                    pdf.text(pdf.internal.pageSize.getWidth() - 1,
                        pdf.internal.pageSize.getHeight() - 0.1, 'Página ' + i + " / " + totalPages);
                    pdf.text(pdf.internal.pageSize.getWidth() - 5,
                        pdf.internal.pageSize.getHeight() - 0.1, 'Representación impresa de un CFDI.');

                    // you can add the line separator as an image, consult the docs below to properly set the place of the image
                    // pdf.addImage(img, 'png', 0, 0, 52, 23)
                }

            }).save();
        },

        async convertBase64() {
            var opt = {
                margin: .5,
                filename: 'Factura_' + this.item.serie + "_" + this.item.folio + ".pdf",
                jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
                html2canvas: { scale: 4, letterRendering: true, },
                pagebreak: {
                    mode: ['avoid-all', 'css', 'legacy']
                },
                autoPaging: 'text'
            }

            //GENRA EL BASE64
            let file = '';
            const jabubu = await html2pdf().from(document.getElementById('invoice')).set(opt).toPdf().get('pdf').then((pdf) => {
                var totalPages = pdf.internal.getNumberOfPages();
                // console.log(totalPages)
                for (let i = 1; i <= totalPages; i++) {
                    pdf.setPage(i);
                    pdf.setFontSize(10);
                    pdf.setTextColor(0);
                    pdf.text(pdf.internal.pageSize.getWidth() - 1,
                        pdf.internal.pageSize.getHeight() - 0.1, 'Página ' + i + " / " + totalPages);
                    pdf.text(pdf.internal.pageSize.getWidth() - 5,
                        pdf.internal.pageSize.getHeight() - 0.1, 'Representación impresa de un CFDI.');
                }

            }).outputPdf();

            file += btoa(jabubu)
            // console.log(file)
            return 'data:application/pdf;base64,' + file
        },

        async descargaComprobante() {
            await this.exportToPDF()
        },

        closeDialogPdf() {
            this.LimpiarFacturaStore();
            this.$emit('cierraDialogPdf')
        },
        LimpiarFacturaStore() {
            let facturaDefault = {
                idFactura: 0,
                folioFiscal: '',
                serie: '',
                folio: '',
                fecha: null,
                formaPago: {},
                condicionesPago: '',
                subTotal: 0,
                descuento: 0,
                moneda: {
                    id: 100,
                    clave: 'MXN',
                    descripcion: 'Peso Mexicano',
                    moneda: 'MXN | Peso Mexicano'
                },
                tipoCambio: 0,
                total: 0,
                tipoComprobante: 'I',
                tipoComprobanteInterno: 'Factura',
                metodoPago: {},
                empresa: {
                    empresa: ''
                },
                cliente: {
                    rfc: '',
                    nombre: '',
                    cliente: '',
                    usoCfdi: {},
                    regimenFiscal: { regimenFiscal: '' }
                },
                rfc: '',
                nombre: '',
                atn: '',
                notas: '',
                estatus: 'Sin Timbrar',
                usuarioCreador: '',
                usuarioModificador: '',
                usuarioAutoriza: '',
                conceptos: [],
                impuestos: {
                    traslados: [],
                    retenciones: [],
                },
                cfdiRelacionados: [
                    {
                        tipoRelacion: {},
                        cfdiRelacionados: [],
                    }
                ],
                timbreFiscalDigital: {
                    folioFiscal: '',
                    fechaTimbrado: new Date(),
                    selloCFDI: { base64: '' },
                    noCertificado: '',
                    noCertificadoSAT: '',
                    selloSAT: { base64: '' },
                    cadenaOriginal: '',
                    serie: '',
                    folio: '',
                    Error: '',
                    archivoXml: '',
                }
            }
            this.$store.state.facturaStore = { ...facturaDefault }
            this.loadingValidarCompra = 3
        },

        closeDialogCorreo() {
            this.dialogCorreo = false;
        },

        async enviaCorreo() {
            console.log('aqui')
            console.log(this.correoEmisor)
            console.log(this.destinatarios)
            if (this.correoEmisor.nombreCorreo == "" || this.correoEmisor.correo == "") {
                this.$toast.add({ severity: "error", summary: "Error", detail: "Los datos de correo del Emisor estan incompletos.", life: 3000, });
                return;
            }
            if (this.destinatarios.length == 0) {
                this.$toast.add({ severity: "error", summary: "Error", detail: "El receptor no cuenta con destinatarios.", life: 3000, });
                return;
            }
            console.log('aqui2')

            this.loading = true;
            this.loadingMensaje = 'Enviando correo...'

            this.correo.archivos = []

            let correos = {
                asunto: this.correo.asunto,
                mensaje: this.correo.mensaje,
                emisor: {
                    nombre: '',
                    correo: 'ventas@laudem-ave.com.mx',
                    contra: 'ContaGo123@',
                    hostt: 'mailc75.carrierzone.com',
                    puerto: 587,
                },
                receptores: [],
                archivos: [],
            }

            var xml_ = {
                base64: this.item.timbreFiscalDigital.archivoXml,
                nombre: this.item.folioFiscal + '.xml'
            }
            var pdf_ = {
                base64: await this.convertBase64(),
                nombre: this.item.folioFiscal + '.pdf'
            }

            correos.receptores = this.destinatarios;
            correos.archivos.push(xml_);
            correos.archivos.push(pdf_);

            console.log(correos)

            try {
                let response = await axios.post('Correos/PostCorreos/' + this.empresa.empresaBase + '/' + this.empresa.idusuariosApp, correos)
                console.log(response.data)
                this.dialogCorreo = false;
                this.loading = false;
                this.$toast.add({ severity: 'success', detail: 'Correo enviado con éxito', life: 5000 });

            } catch (error) {
                this.$toast.add({ severity: 'error', detail: 'Error al enviar:' + error.response.data, life: 5000 });
                console.log(error)
                this.loading = false;
            }
        },

        async descargaComprobanteXml() {
            let archivo = this.item.timbreFiscalDigital.archivoXml;
            let nombreA = this.item.folioFiscal
            this.download(archivo, nombreA, 'xml');
        },

        download(archivo, nombre, tipo) {
            var arrBuffer = this.base64ToArrayBuffer(archivo);
            var newBlob = new Blob([arrBuffer]);

            var data = window.URL.createObjectURL(newBlob);
            var link = document.createElement('a');
            document.body.appendChild(link);
            link.href = data;
            link.download = nombre + '.' + tipo;
            link.click();
            window.URL.revokeObjectURL(data);
            link.remove();
        },

        base64ToArrayBuffer(base64) {
            var binary_string = window.atob(base64);
            var len = binary_string.length;
            var bytes = new Uint8Array(len);
            for (var i = 0; i < len; i++) {
                bytes[i] = binary_string.charCodeAt(i);
            }
            return bytes.buffer;
        },
    }
};
</script>
<style>
.col {
    background-color: white;
}

.grid {
    background-color: white;
}

.ocult thead {
    display: none;
}

.ocult table {
    border: none
}

.page-break-inside {
    page-break-inside: avoid;
}

.p-datatable .p-datatable-thead>tr>th {
    border-bottom: 2px solid #E64747;
}
</style>